import type { SigninRequest, User } from 'oidc-client';
import { createContext, type PropsWithChildren, useContext } from 'react';
import AuthService from '../services/auth.service';

export type AuthContextProps = {
  signinRedirectCallback: () => Promise<User>;
  signinRedirect: (idp?: string, loginQueryParams?: unknown) => Promise<void>;
  createSigninRequest: () => Promise<SigninRequest>;
  logout: () => Promise<void>;
  signoutRedirectCallback: () => Promise<void>;
  signinSilent: () => Promise<User>;
};

export const AuthContext = createContext<AuthContextProps>(undefined!);

export const AuthProvider = ({ children }: PropsWithChildren) => {
  const authService = new AuthService();
  const value = { ...authService };
  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const AuthConsumer = AuthContext.Consumer;

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within AuthProvider');
  }
  return context;
};
